import React, { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import {
  Box, VStack, FormControl, FormLabel, Input, InputGroup, InputRightElement,
  IconButton, Button, Text, Link, Alert, AlertIcon, Heading, Image
} from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { authState } from '../../state/authState';
import { authService } from '../../services/api';

export const LoginForm = () => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const setAuth = useSetRecoilState(authState);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await authService.login({ identifier, password });
      setAuth({
        user: response.data.user,
        isAuthenticated: true,
        isLoading: false
      });
      navigate('/calculator');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      maxW="400px"
      mx="auto"
      mt={20}
      p={8}
      bg="rgba(255, 255, 255, 0.95)"
      borderRadius="lg"
      boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.5)"
      backdropFilter="blur(10px)"
      border="1px solid"
      borderColor="gray.200"
    >
      <VStack spacing={6} as="form" onSubmit={handleSubmit}>
        <Image src="/img/iadc-logo.png" alt="IADC" h="50px" />
        <Heading size="lg" color="brand.500">Sign In</Heading>
        <Text color="gray.600" textAlign="center">Geothermal Well Complexity Index</Text>

        {error && (
          <Alert status="error" borderRadius="md">
            <AlertIcon />
            {error}
          </Alert>
        )}

        <FormControl isRequired>
          <FormLabel>Email or Username</FormLabel>
          <Input
            type="text"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            placeholder="your@email.com or username"
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Password</FormLabel>
          <InputGroup>
            <Input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
            />
            <InputRightElement>
              <IconButton
                icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                onClick={() => setShowPassword(prev => !prev)}
                variant="ghost"
                size="sm"
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              />
            </InputRightElement>
          </InputGroup>
        </FormControl>

        <Button
          type="submit"
          colorScheme="red"
          width="100%"
          isLoading={isLoading}
        >
          Sign In
        </Button>

        <Text fontSize="sm" color="gray.600">
          Don't have an account?{' '}
          <Link as={RouterLink} to="/register" color="brand.500" fontWeight="semibold">
            Register
          </Link>
        </Text>
      </VStack>
    </Box>
  );
};

export default LoginForm;
